<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <!-- Start Banner -->
    <div v-if="pgLoading" class="webkit-animation webkit-100-340">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <div class="page-title-content">
              <h2><label class="webkit-animation webkit-250-75"></label></h2>
              <ul>
                <li class="webkit-pad5">
                  <label class="webkit-animation webkitpx-100-50"></label>
                </li>
                <li class="webkit-pad5">
                  <label class="webkit-animation webkitpx-100-50"></label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!pgLoading"
      class="page-title-area text-center"
      :class="locale == 'ar' ? 'rtl' : 'ltr'"
      :style="
        info.image
          ? 'background-image: url(' + info.image.url + ') !important'
          : ''
      "
    >
      <div class="d-table w-100">
        <div class="d-table-cell">
          <div class="container">
            <div class="page-title-content">
              <h1 class="text-white">{{ $t("donationVoucher.title") }}</h1>
              <ul class="d-flex justify-content-center">
                <li>
                  <router-link
                    :to="{ name: 'home' }"
                    class="router-link-active text-white"
                  >
                    {{ $t("home.title") }}&nbsp;
                    <i class="far fa-chevron-left"></i>
                  </router-link>
                </li>
                <li class="text-white">
                  &nbsp; {{ $t("donationVoucher.title") }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner -->

    <section
      class="contact-section pt-50"
      :class="locale == 'ar' ? 'rtl' : 'ltr'"
    >
      <div class="container">
        <div class="row d-flex justify-center align-center">
          <div class="col-lg-6 order-lg-1 order-2">
            <div
              v-if="pgLoading"
              class="contact-area webkit-animation webkit-100-500"
            ></div>
            <div v-if="!pgLoading" class="contact-area">
              <div class="contact-form border rounded rounded-5 p-5">
                <form id="contactForm">
                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <p class="text-center" style="font-size: 16px">
                        {{
                          $route.query.project
                            ? "إهداء عن مشروع:  " + this.row.project_name
                            : this.row.project_name
                        }}
                      </p>
                    </div>
                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label
                          class="control-label"
                          :style="
                            this.locale == 'ar'
                              ? 'direction: rtl !important;text-align: right !important'
                              : 'direction: ltr !important;text-align: left !important'
                          "
                        >
                          {{
                            $t("donationVoucher.donation_voucher_value")
                          }}</label
                        >
                        <select class="form-control" v-model="row.price">
                          <option value="">أختر مبلغ الهدية</option>
                          <option value="1">1 دينار</option>
                          <option value="5">5 دينار</option>
                          <option value="50">50 دينار</option>
                          <option value="100">100 دينار</option>
                          <option value="500">500 دينار</option>
                        </select>
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label
                          class="control-label"
                          :style="
                            this.locale == 'ar'
                              ? 'direction: ltr !important;text-align: right !important'
                              : 'direction: ltr !important;text-align: left !important'
                          "
                        >
                          {{ $t("donationVoucher.from_name") }}</label
                        >
                        <input
                          type="text"
                          :placeholder="$t('donationVoucher.from_name')"
                          class="form-control dir-ltr"
                          v-model="row.from_name"
                          :style="
                            this.locale == 'ar'
                              ? 'direction: ltr !important;text-align: right !important'
                              : 'direction: ltr !important;text-align: left !important'
                          "
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label
                          class="control-label"
                          :style="
                            this.locale == 'ar'
                              ? 'direction: ltr !important;text-align: right !important'
                              : 'direction: ltr !important;text-align: left !important'
                          "
                        >
                          {{ $t("donationVoucher.to_name") }}</label
                        >
                        <input
                          type="text"
                          :placeholder="$t('donationVoucher.to_name')"
                          class="form-control dir-ltr"
                          v-model="row.to_name"
                          :style="
                            this.locale == 'ar'
                              ? 'direction: ltr !important;text-align: right !important'
                              : 'direction: ltr !important;text-align: left !important'
                          "
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <!-- <div class="form-group">
                        <label class="control-label"
                               :style="(this.locale == 'ar') ? 'direction: ltr !important;text-align: right !important' :'direction: ltr !important;text-align: left !important'">
                          {{ $t('contact.body') }} ({{ counter }})</label>
                        <textarea
                            class="form-control"
                            :placeholder="$t('contact.body')"
                            cols="30"
                            rows="6"
                            v-model="row.message">
                                                        </textarea>
                        <div class="help-block with-errors"></div>
                      </div> -->

                      <!--  <br/><br/>
                       <div class="col-lg-12 col-md-12">
 >>>>>>> 10192fe742c43f73d6e3e9722de795c0b38aa714
                       <div class="form-group"
                           :style="(this.locale == 'ar') ? 'float: right' :'float: left'">
                           <input
                               type="checkbox"
                               v-model="is_gift"
                               value="1"
                               :style="(this.locale == 'ar') ? 'direction: ltr !important;text-align: right !important' :'direction: ltr !important;text-align: left !important'">
                           <span> &nbsp;&nbsp;&nbsp;&nbsp; {{ $t('donationVoucher.print_gift') }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                         </div> -->
                      <!-- <div class="form-group">
                        <input type="text"
                               :placeholder="$t('donationVoucher.print_gift_to_name')"
                               class="form-control dir-ltr"
                               v-model="row.gift_to_name"
                               :style="(this.locale == 'ar') ? 'direction: ltr !important;text-align: right !important' :'direction: ltr !important;text-align: left !important'">
                        <div class="help-block with-errors"></div>

                      </div> -->
                      <!-- </div> -->
                    </div>

                    <div class="col-lg-12">
                      <div class="send-btn">
                        <button
                          :style="this.locale == 'ar' ? 'text-align:right' : ''"
                          type="button"
                          @click="sendMessage"
                          :disabled="btnLoading"
                          class="btn theme_btn theme_btn_bg text-center"
                        >
                          <div v-if="btnLoading">
                            <div class="loader loader-xs loader-center"></div>
                          </div>
                          <div v-if="!btnLoading">
                            {{ $t("app.donation_now") }}
                            <i class="flaticon-left"></i>
                            <span></span>
                          </div>
                        </button>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-6 order-lg-2 order-1">
            <img
              :src="this.row.current_selected"
              class="w-100"
              loading="lazy"
            />

            <label
              class="control-label mt-3"
              :style="
                this.locale == 'ar'
                  ? 'direction: ltr !important;text-align: right !important'
                  : 'direction: ltr !important;text-align: left !important'
              "
            >
              {{ $t("donationVoucher.choose_template") }}</label
            >
            <vue-select-image
              :dataImages="images"
              @onselectimage="onSelectImage"
            >
            </vue-select-image>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";
import { trackCheckout } from "@/helpers/pixel";
import VueSelectImage from "vue-select-image";
// add stylesheet
require("vue-select-image/dist/vue-select-image.css");

export default {
  name: "List",
  components: {
    VueSelectImage,
  },
  data() {
    return {
      auth: {
        access_token: "",
      },
      images: [
        {
          id: "3",
          src: "/assets/img/donation-voucher/image_3.jpeg",
          alt: "Alt Image 3",
        },
        {
          id: "1",
          src: "/assets/img/donation-voucher/image_1.jpeg",
          alt: "Alt Image 1",
        },
        {
          id: "2",
          src: "/assets/img/donation-voucher/image_2.jpeg",
          alt: "Alt Image 2",
        },
      ],
      //
      row: {
        price: "",
        from_name: "",
        to_name: "",
        message: "",
        template: 3,
        project_name: "الصدقة الجارية",
        is_gift: "",
        gift_to_name: "",
        current_selected: "/assets/img/donation-voucher/image_3.jpeg",
      },

      counter: 300,
      locale: "ar",
      info: "",
      pgLoading: true,
      btnLoading: false,
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
      if (localStorage.getItem("first_name")) {
        this.row.from_name =
          localStorage.getItem("first_name") +
          " " +
          localStorage.getItem("last_name");
      }
    }

    if (this.$route.query.project) {
      this.row.project_name = this.$route.query.project;
    }
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/14",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    sendMessage() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/donation-vouchers",
        method: "POST",
        data: {
          is_gift: this.row.is_gift,
          gift_to_name: this.row.gift_to_name,
          from_name: this.row.from_name,
          to_name: this.row.to_name,
          project_name: this.row.project_name,
          price: this.row.price,
          message: this.row.message,
          template: this.row.template,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.btnLoading = false;
          trackCheckout({
            value: this.row.price,
            currency: "KWD",
            content_name: this.row.project_name,
            content_type: "donation_voucher",
            num_items: 1,
          });

          this.clearRow();

          iziToast.success({
            icon: "ti-check",
            title: "",
            message: "تم إرسال الرسالة بنجاح",
          });

          if (res.data.link) {
            window.open(res.data.link, "_self");
          }
        })
        .catch((err) => {
          this.btnLoading = false;

          iziToast.warning({
            icon: "ti-alert",
            title: "Wow-man,",
            message: err.response ? err.response.data.message : "" + err,
          });
        })
        .finally(() => {});
    },

    onKeyDown() {
      //this.counter -= count(this.row.message)
    },
    clearRow() {
      this.row.price = "";
      this.row.from_name = "";
      this.row.to_name = "";
      this.row.message = "";
    },

    onSelectImage(image) {
      this.row.template = image.id;
      this.row.current_selected = image.src;
    },
  },
};
</script>

<style>
.btn-size {
  cursor: pointer;
  width: 140px;
  height: 50px;
}

.control-label {
  width: 100%;
}

.vue-select-image__wrapper {
  display: flex;
}
</style>
